import React from 'react';
import {
  Grid,
  FormControlLabel,
  Checkbox,
  GridJustification,
  GridWrap,
  GridSize,
  makeStyles
} from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';

export interface Props {
  value: string[];
  onChange: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  options: {
    label: string;
    value: string;
  }[];
  gridContainerProps?: {
    justify?: GridJustification;
    wrap?: GridWrap;
  };
  gridItemProps?: {
    xs?: GridSize;
  };
}

const CheckboxGroupPresenter: React.FC<Props> = (props) => {
  const { labelText } = useStyles();

  return (
    <Grid container alignItems="center" {...props.gridContainerProps}>
      {props.options.map((option, index) => (
        <Grid item key={index} {...props.gridItemProps}>
          <FormControlLabel
            checked={props.value.includes(option.value)}
            control={
              <Checkbox
                color="primary"
                name={option.value}
                onChange={props.onChange}
              />
            }
            label={
              <CustomizedTypography variant="body2" className={labelText}>
                {option.label}
              </CustomizedTypography>
            }
          />
        </Grid>
      ))}
    </Grid>
  );
};

const useStyles = makeStyles((theme) => ({
  labelText: {
    marginTop: 4
  }
}));

export default CheckboxGroupPresenter;
